import type { FaireProductEntity } from "../../entity_types/product";

export const p_9xxckzw2r6: FaireProductEntity = {
  token: "p_9xxckzw2r6",
  type: "product",
  name: "Shell Notes",
  brandName: "Chronicle Books",
  imageUrl:
    "https://cdn.faire.com/fastly/17f748732bd9139587340c2bed7470d0db5fde64a8279c21436afba60a201acb.jpeg",
  priceDollars: 8.29,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b09aee95d1aa7a3cd5ce25862d78b3f15a16aca80df23c7de572680412c94ece.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
